/**
 * @file Accessibility.js
 * @author Stanley Chen
 * @description Component that displays the accessibility statement for the website,
 * detailing compliance with accessibility standards and available accommodations
 */

import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import './Privacy.css';

const Accessibility = () => {
    const ref = useRef(null);
    const isInView = useInView(ref, { once: true, amount: 0.2 });

    return (
        <section className="privacy-section" id="privacy" ref={ref}>
            <img
                src="/images/mtnbg.jpg"
                alt="Background"
                className="privacy-background"
            />
            <div className="privacy-container">
                <motion.h1
                    className="privacy-title"
                    initial={{ opacity: 0, y: -20 }}
                    animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: -20 }}
                    transition={{ duration: 0.6 }}
                >
                    ACCESSIBILITY STATEMENT
                </motion.h1>

                <div className="privacy-card">
                    <div className="privacy-content">
                    <h2>Kiku Japanese Steakhouse and Sushi Bar - Accessibility Statement</h2>
  <p>
    Kiku Japanese Steakhouse & Sushi is committed to ensuring that our website is accessible to all individuals, including those with disabilities. We strive to improve the user experience for everyone, and we are continuously gathering feedback and making improvements to make our site more accessible.
  </p>
  
  <h3>Conformance</h3>
  <p>
    To provide an excellent experience for all users, we adhere to the <strong>Web Content Accessibility Guidelines (WCAG)</strong>. These guidelines are divided into three levels of accessibility conformance: Level A, Level AA, and Level AAA. At Kiku Japanese Steakhouse & Sushi, we have chosen <strong>Level AA</strong> as our target for website accessibility. We are fully committed to regularly monitoring our site to ensure we maintain this level of compliance.
  </p>
  
  <h3>Third-Party Vendors</h3>
  <p>
    While we strive to provide a fully accessible website, we also collaborate with third-party vendors for services such as online ordering, delivery, reservations, event management, and social media platforms. We encourage these vendors to ensure that their content is also accessible and user-friendly, though please note that we do not have control over the content they provide on our website.
  </p>
  
  <h3>Feedback</h3>
  <p>
    We are constantly working to improve the accessibility of our website. If you have any feedback or suggestions on how we can enhance the accessibility or usability of the Kiku Japanese Steakhouse & Sushi website, we would love to hear from you. Please feel free to reach out to us via email at:
  </p>
  <p><strong>Email:</strong> <a href="mailto:kikusteakhouse8868@gmail.com">kikusteakhouse8868@gmail.com</a></p>
  <p>
    We aim to respond to all inquiries within <strong>2 business days</strong>.
  </p>
  
  <h3>Assistance</h3>
  <p>
    If you encounter any difficulties navigating our site or need further assistance, we are here to help. Please contact us at <strong>302-378-8868</strong> during our regular business hours, and we will be happy to assist you with any questions or concerns you may have.
  </p>
  
  <h3>Commitment to Accessibility</h3>
  <p>
    We are continuously working towards making our digital content accessible to everyone, and we appreciate your patience as we improve our website. Thank you for choosing Kiku Japanese Steakhouse & Sushi!
  </p>
                    </div>

                </div>
            </div>
        </section>
    );
};

export default Accessibility;
